// extracted by mini-css-extract-plugin
export default {"tagsContainer":"Tags_tagsContainer__aNfgH","tag":"Tags_tag__2so54","remove":"Tags_remove__QXWN3"};